import { EVENTS } from './events'

export const GTM_EVENTS = {
  [EVENTS.SIGN_UP_SUCCESS]: 'sign_up',
  [EVENTS.SIGN_IN_SUCCESS]: 'login',
  [EVENTS.CHECKOUT_SUCCESS]: 'purchase',
  [EVENTS.START_TRIAL]: 'close_convert_lead',
} as const
